import React from 'react'
import { BusinessIcon, PersonIcon2 } from '../../Assets/AllSvg'
import { BsThreeDots } from 'react-icons/bs'
import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react'

const ProfileTables = () => {
    return (
        <div>
            <div className='text-sm mt-8 py-[16px]'>
                <div className='flex justify-between sm:flex-row flex-col gap-2 sm:items-center pt-[16px] pb-[12px] border-b-[1px] border-[#e5e5eb]'>
                    <div className='text'>
                        <span className='text-[#1a1b25] font-bold text-[20px]'>Login sessions</span>
                        <p className='text-[#414552] mt-1'>Places where you're logged into Stripe.</p>
                    </div>
                    <button className='input_focus_shadow h-[30px] w-fit rounded-[6px] text-[#1a1b25] text-[14px] font-semibold p-[0_8px] flex items-center gap-2'>Sign out all other sessions</button>
                </div>
                <div className='profile-table w-full overflow-x-auto'>
                    <table className='md:w-full w-[740px] overflow-x-auto table-auto text-[11px] text-start'>
                        <thead>
                            <tr>
                                <th>LOCATION</th>
                                <th>DEVICE</th>
                                <th>IP ADDRESS</th>
                                <th>TIME</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>India (GJ)</td>
                                <td>Chrome - Windows</td>
                                <td>49.36.80.22</td>
                                <td>4 minutes ago</td>
                                <td>Current session</td>
                            </tr>
                            <tr>
                                <td>India (GJ)</td>
                                <td>Chrome - Linux</td>
                                <td>49.36.80.22</td>
                                <td>17 hours ago</td>
                                <td>Expired</td>
                            </tr>
                            <tr>
                                <td>India (GJ)</td>
                                <td>Chrome - Windows</td>
                                <td>49.36.80.22</td>
                                <td>17 hours ago</td>
                                <td>Expired</td>
                            </tr>
                            <tr>
                                <td>India (GJ)</td>
                                <td>Chrome - Linux</td>
                                <td>49.36.80.22</td>
                                <td>17 hours ago</td>
                                <td>Expired</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='text-sm mt-8 py-[16px]'>
                <div className='flex justify-between items-center pt-[16px] pb-[12px] border-b-[1px] border-[#e5e5eb]'>
                    <div className='text'>
                        <span className='text-[#1a1b25] font-bold text-[20px]'>Accounts</span>
                        <p className='text-[#414552] mt-1'>The list of accounts to which you are a member.</p>
                    </div>
                </div>
                <div className='profile-table w-full overflow-x-auto'>
                    <table className='md:w-full w-[740px] table-auto text-[11px] text-start'>
                        <thead>
                            <tr>
                                <th>NAME</th>
                                <th>Role</th>
                                <th>ID</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className='flex items-center gap-2'>
                                        <BusinessIcon />
                                        Unnamed Account
                                    </div>
                                </td>
                                <td>
                                    <div className='flex items-center gap-2'>
                                        <PersonIcon2 className="w-[12px] h-[12px] fill-gray-600" />
                                        Administrator (Owner)
                                    </div>
                                </td>
                                <td>acct_1N8FhsSH60np6AHN</td>
                                <td>
                                    <Menu placement='top-end'>
                                        <MenuHandler>
                                            <button className='input_focus_shadow h-[26px] rounded-[6px] text-[#1a1b25] text-[14px] font-semibold p-[0_8px]'><BsThreeDots /></button>
                                        </MenuHandler>
                                        <MenuList className='py-[8px] px-[0] max-w-[168px]'>
                                            <MenuItem className='focus:outline-none flex gap-2 items-center rounded-none text-[#625afa] hover:bg-[#f7f7f7] py-[5px] font-medium text-[14px] px-[12px] hover:text-[#625afa]'>Copy url</MenuItem>
                                            <p className='mt-1 px-[12px] focus:outline-none font-medium text-[#afb0ba]'>Leave account…</p>
                                        </MenuList>
                                    </Menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    )
}

export default ProfileTables